import { styled } from '../theme'

export const SpaceBetween = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 11px;
`
